import React, { useState, useEffect } from 'react';
import api from '../../services/api';

function Sair(){
    const [msg, setMsg] = useState('');
    useEffect(() => {

        async function getSair(){
            let dados = await api.get('sair');
            if(dados.data.msg === 'token invalido.'){
                window.localStorage.clear();
                window.location = '../Logue-se';
            }else{
                setMsg(dados.data.msg);
                setTimeout(() => {
                    window.localStorage.clear();
                    window.location = './';
                  //  return ('');
                }, 500);
            }
        }


        getSair();
        
    }, []);

    return (<>
    <br/>
    <br/>
    <br/>
    <center>
    {msg ?? ''}
    </center>
    <br/>

    </>)
}

export default Sair;
